import { Box } from '@breathelife/mui';
import { ReactElement, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { LeadStatus } from '@breathelife/types';

import { ChevronLeftIcon } from '../../../../../../Assets/Icons/ChevronLeftIcon';
import { Application } from '../../../../../../Models/Application';
import { ContentHeading, CtaButton } from '../../Styles';
import { ApplicationHeaderInfo } from './ApplicationHeaderInfo';
import { ApplicationHeaderProgress } from './ApplicationHeaderProgress';
import { ApplicationView } from './Engine/ApplicationView';

type ApplicationDetailProps = {
  customView?: (props: any) => ReactElement | null;
  application: Application;
  leadStatus: LeadStatus;
  onClose: () => void;
};

export function ApplicationDetail({
  customView,
  application,
  leadStatus,
  onClose,
}: ApplicationDetailProps): ReactElement | null {
  const { t } = useTranslation();

  return (
    <Fragment>
      <ContentHeading py={2} px={3}>
        <Box display='flex' alignItems='flex-start'>
          <CtaButton startIcon={<ChevronLeftIcon />} variant='outlined' onClick={onClose}>
            {t('tabs.needsAnalysis.back')}
          </CtaButton>

          <Box ml={2}>
            <ApplicationHeaderInfo application={application} />
          </Box>
        </Box>

        <Box textAlign='right'>
          <ApplicationHeaderProgress application={application} status={leadStatus} />
        </Box>
      </ContentHeading>

      <Box p={3}>
        <ApplicationView customView={customView} application={application} leadStatus={leadStatus} />
      </Box>
    </Fragment>
  );
}
